import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "history-drawer-component-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/drawer_bg.png",
  alt: "",
  class: "bg"
}, null, -1)
const _hoisted_3 = { class: "history-drawer-title" }
const _hoisted_4 = { class: "title flex-ter" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/vip.png",
  alt: ""
}, null, -1)
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "scroll-bar-content" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "line-content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "point" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "line"
}
const _hoisted_12 = { class: "info-content" }
const _hoisted_13 = { class: "info-time flex-ter" }
const _hoisted_14 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/new.png",
  alt: ""
}
const _hoisted_15 = { class: "product" }
const _hoisted_16 = { class: "product-title flex-ter" }
const _hoisted_17 = { class: "name line--only" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/right.png",
  alt: ""
}, null, -1)
const _hoisted_20 = { class: "prodyct-img-content flex" }
const _hoisted_21 = { class: "no-more" }

import { Close } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import Image from '@/components/common/Image.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useRtfix } from '@/store'
import { QueryShareLinkListRespVO } from '@/service/goods'

export default /*#__PURE__*/_defineComponent({
  props: {
    list: { type: Array, required: true }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  list: QueryShareLinkListRespVO[]
}
const visible = ref(false)
const router = useRouter()

const jump = (item: { shareCode: string }) => {
  router.push(useRtfix('ckbChoice', { params: { code: item.shareCode } }))
}
const open = () => {
  visible.value = true
}
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    size: 480,
    "destroy-on-close": "",
    "show-close": false,
    "append-to-body": true,
    "modal-class": "history-drawer-component"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_icon, {
          class: "icon-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        }),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_unref(t)('一对一专属选品提案')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('CKB对于高级会员一对一定制化选品提案。将喜欢的商品加入心愿清单，CKB会为您快速创建商品。')), 1)
        ]),
        _createVNode(_component_el_scrollbar, {
          class: "scroll-bar",
          always: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "scroll-bar-item",
                  key: index,
                  onClick: ($event: any) => (jump(item))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    (index !== __props.list.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(item.createTime?.slice(0, 10)), 1),
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1),
                        _createElementVNode("span", {
                          class: "num",
                          innerHTML: _unref(t)('共X件商品').replace('X', `<span>${item.atlasCodes?.length}</span>`)
                        }, null, 8, _hoisted_18),
                        _hoisted_19
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        (item.headerImages?.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.headerImages, (i, k) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (k < 3)
                                  ? (_openBlock(), _createBlock(Image, {
                                      src: i,
                                      fit: "cover",
                                      class: "img",
                                      key: k
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(3, (i, k) => {
                              return _createVNode(Image, {
                                key: k,
                                src: i,
                                fit: "cover",
                                class: "img"
                              }, null, 8, ["src"])
                            }), 64))
                      ])
                    ])
                  ])
                ], 8, _hoisted_8))
              }), 128)),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('没有更多了')), 1)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})